// Configuration des textes multilingues pour les menus du restaurant

export const menuTexts = {
  fr: {
    // Titres des sections
    sections: {
      starters: 'Entrées',
      mains: 'Plats',
      desserts: 'Desserts'
    },
    
    // Plats du menu restaurant
    dishes: {
      restaurant: {
        title: 'Menu "Le Sourdin"',
        starters: [
          'Assiette Sourdine (Terrine de Campagne, Jambon, Andouille de Vire)',
          'Gratinée Normande (Pomme de terre, Andouille de Vire, Pommes, Camembert, Crème)',
          'Saumon mariné aux aromates',
          'Assiette d\'Andouille'
        ],
        mains: [
          'Pièce de Bœuf, sauce Camembert',
          'Andouillette Grillée, sauce Moutarde',
          'Jambon braisé, sauce Pommeau',
          'Pavé de Merlu Beurre de citron'
        ],
        desserts: [
          'Mousse au Chocolat',
          'Tarte Normande et sa douceur Vanille',
          'Coupe Normande',
          'Croquant de Camembert'
        ]
      },
      brasserie: {
        title: 'Menu Brasserie',
        starters: [
          'Entrée du Jour',
          'Terrine de Campagne',
          'Soupe de Poisson'
        ],
        mains: [
          'Plat du Jour',
          'Dos de Colin huile d\'olive aux aromates',
          'Suprême de volaille, sauce Pommeau'
        ],
        desserts: [
          'Dessert du Jour',
          'Assiette de Camembert sur salade',
          'Mousse au chocolat',
          'Tarte aux pommes'
        ]
      }
    },
    
    // Options des formules
    formuleOptions: {
      option1: 'Entrée + Plat',
      option2: 'Plat + Dessert',
      option3: 'Entrée + Plat + Dessert'
    },
    
    // Textes du footer
    footer: {
      downloadMenu: 'Télécharger notre menu',
      homemade: 'Tous nos plats sont faits maison et élaborés sur place à partir de produits bruts.',
      priceInfo: 'Prix nets, service compris.',
      dailyMenu: 'Le menu de la brasserie change tous les jours, n\'hésitez pas à nous demander les suggestions du jour.'
    },    
  },
  
  en: {
    // Titres des sections
    sections: {
      starters: 'Starters',
      mains: 'Main Courses',
      desserts: 'Desserts'
    },
    
    // Plats du menu restaurant
    dishes: {
      restaurant: {
        title: 'Menu "Le Sourdin"',
        starters: [
          'Sourdine Plate (Paté, Ham, Vire Andouille Sausage)',
          'Norman Potato Gratin (Potatoes, Vire Andouille Sausage, Apples, Camembert, Cream)',
          'Marinated Salmon with Herbs',
          'Plate of Andouille'
        ],
        mains: [
          'Piece of Beef with Camembert Sauce',
          'Grilled Andouillette with Mustard Sauce',
          'Braised Ham with Pommeau Sauce',
          'Lemon Butter Hake Steak'
        ],
        desserts: [
          'Chocolate Mousse',
          'Normandy Apple Tart',
          'Apple Calvados Sorbet',
          'Crunchy Camembert served with a Green Salad'
        ]
      },
      brasserie: {
        title: 'Brasserie Menu',
        starters: [
          'Starter of the Day',
          'Country Terrine',
          'Fish Soup'
        ],
        mains: [
          'Dish of the Day',
          'Hake Fillet with Olive Oil and Herbs',
          'Chicken Supreme with Pommeau Sauce'
        ],
        desserts: [
          'Dessert of the Day',
          'Camembert Cheese Plate with Salad',
          'Chocolate Mousse',
          'Apple Pie'
        ]
      }
    },
    
    // Options des formules
    formuleOptions: {
      option1: 'Starter + Main Course',
      option2: 'Main Course + Dessert',
      option3: 'Starter + Main Course + Dessert'
    },
    
    // Textes du footer
    footer: {
      downloadMenu: 'Download our menu',
      homemade: 'All our dishes are homemade and prepared on site from raw products.',
      priceInfo: 'Net prices, service included.',
      dailyMenu: 'The brasserie menu changes every day, do not hesitate to ask us for the suggestions of the day.'
    }
  }
};

// Fonction utilitaire pour récupérer les textes des menus en fonction de la langue
export const getMenuText = (lang, path) => {
  const keys = path.split('.');
  let result = menuTexts[lang];
  
  for (const key of keys) {
    if (result && result[key] !== undefined) {
      result = result[key];
    } else {
      return undefined;
    }
  }
  
  return result;
};

// Exportations pour maintenir la compatibilité avec les composants existants
export const restaurantMenus = [
  {
    id: 'sourdin',
    title: menuTexts.fr.dishes.restaurant.title,
    price: 27.00,
    starters: menuTexts.fr.dishes.restaurant.starters,
    mains: menuTexts.fr.dishes.restaurant.mains,
    desserts: menuTexts.fr.dishes.restaurant.desserts,
    image: 'menu-restaurant.jpg'
  }
];

export const brasserieMenus = [
  {
    id: 'formule',
    title: 'Formule',
    price: 15.00,
    description: 'Entrée du jour + Plat du jour ou Plat du Jour + Dessert du jour',
    image: 'formule.jpg'
  },
  {
    id: 'brasserie',
    title: menuTexts.fr.dishes.brasserie.title,
    price: 17.00,
    starters: menuTexts.fr.dishes.brasserie.starters,
    mains: menuTexts.fr.dishes.brasserie.mains,
    desserts: menuTexts.fr.dishes.brasserie.desserts,
    image: 'menu-brasserie.jpg'
  }
];
